<template>
    <div class="dm-flex-1 dm-flex-row dm-justify-content-center dm-align-items-center dm-flex-wrap">
        <button 
            @click="goToPrevious" 
            class="app-calendar-arrow" 
            :class="{'app-calendar-arrow-disabled': isAtStart, 'app-print-hide': !showOnPrint}"
            aria-label="Previous week"
        >
            <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
        </button>
        <div class="app-calendar-week-label">
            {{ weekDisplayDate }}
        </div>
        <button 
            @click="goToNext" 
            class="app-calendar-arrow" 
            :class="{'app-calendar-arrow-disabled': isAtEnd, 'app-print-hide': !showOnPrint}"
            aria-label="Next week"
        >
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'WeekNavigator',
    props: {
        weekDisplayDate: {
            type: String,
            required: true
        },
        isAtStart: {
            type: Boolean,
            default: false
        },
        isAtEnd: {
            type: Boolean,
            default: false
        },
        showOnPrint: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToPrevious() {
            if (!this.isAtStart) {
                this.$emit('previous');
            }
        },
        goToNext() {
            if (!this.isAtEnd) {
                this.$emit('next');
            }
        }
    }
}
</script>